'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dAccount$002dPreferences from "./mealorama.-Account-Preferences.js";
import * as $j_mealorama$002e$002dAccount$002dPreferences$0024$0024anon$002417 from "./mealorama.-Account-Preferences$$anon$17.js";
import * as $j_mealorama$002e$002dAccount$002dPreferences$0024$0024anon$002418 from "./mealorama.-Account-Preferences$$anon$18.js";
import * as $j_mealorama$002e$002dAccount$002dPreferences$0024$0024anon$002419 from "./mealorama.-Account-Preferences$$anon$19.js";
import * as $j_mealorama$002e$002dAccount$002dPreferences$0024$0024anon$002420 from "./mealorama.-Account-Preferences$$anon$20.js";
import * as $j_mealorama$002e$002dScheduled$002dMeal$002dPreferences$0024 from "./mealorama.-Scheduled-Meal-Preferences$.js";
var $p;
function $p_Lmealorama_AccountPreferences$__decoders$lzyINIT5$1__sr_LazyRef__ALzio_json_JsonDecoder($thiz, decoders$lzy5$1) {
  if (decoders$lzy5$1.G) {
    var $x_1 = decoders$lzy5$1.H;
  } else {
    var this$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lzio_json_JsonDecoder$(), $j_mealorama$002e$002dScheduled$002dMeal$002dPreferences$0024.$m_Lmealorama_ScheduledMealPreferences$().ts().aO), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
    var evidence$1__runtimeClass;
    var evidence$1__runtimeClass = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lzio_json_JsonDecoder.l();
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    var elementClass = evidence$1__runtimeClass;
    capacity = 0;
    size = 0;
    var isCharArrayBuilder = (elementClass === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_C.l());
    jsElems = [];
    var it = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
    while (it.l()) {
      var elem = it.k();
      var unboxedElem = (isCharArrayBuilder ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uC(elem) : ((elem === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_scm_ArrayBuilder$().b1(elementClass) : elem));
      jsElems.push(unboxedElem);
    }
    var $x_1 = decoders$lzy5$1.ad($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_scm_ArrayBuilder$().b5(((elementClass === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_V.l()) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_jl_Void.l() : (((elementClass === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_sr_Null$.l()) || (elementClass === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_sr_Nothing$.l())) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_O.l() : elementClass)), jsElems));
  }
  return $x_1;
}
export { $p_Lmealorama_AccountPreferences$__decoders$lzyINIT5$1__sr_LazyRef__ALzio_json_JsonDecoder as $p_Lmealorama_AccountPreferences$__decoders$lzyINIT5$1__sr_LazyRef__ALzio_json_JsonDecoder };
function $p_Lmealorama_AccountPreferences$__decoders$5__sr_LazyRef__ALzio_json_JsonDecoder($thiz, decoders$lzy5$2) {
  return (decoders$lzy5$2.G ? decoders$lzy5$2.H : $p_Lmealorama_AccountPreferences$__decoders$lzyINIT5$1__sr_LazyRef__ALzio_json_JsonDecoder($thiz, decoders$lzy5$2));
}
export { $p_Lmealorama_AccountPreferences$__decoders$5__sr_LazyRef__ALzio_json_JsonDecoder as $p_Lmealorama_AccountPreferences$__decoders$5__sr_LazyRef__ALzio_json_JsonDecoder };
function $p_Lmealorama_AccountPreferences$__encoders$lzyINIT5$1__sr_LazyRef__sci_List__Lzio_json_ProductMeta__sci_List($thiz, encoders$lzy5$1, fieldLabels$9, meta$28) {
  if (encoders$lzy5$1.G) {
    var $x_1 = encoders$lzy5$1.H;
  } else {
    var allEncoders = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lzio_json_JsonEncoder$(), $j_mealorama$002e$002dScheduled$002dMeal$002dPreferences$0024.$m_Lmealorama_ScheduledMealPreferences$().ts().aA), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
    var this$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(fieldLabels$9, allEncoders);
    var f = ((x$1$2) => {
      var label = x$1$2.z();
      return meta$28.ag.M(label);
    });
    _return: {
      var result;
      var l$tailLocal1 = this$3;
      while (true) {
        if (l$tailLocal1.b()) {
          var result = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
          break;
        } else {
          var h = l$tailLocal1.e();
          var t = l$tailLocal1.c();
          if ((!(!f(h)))) {
            l$tailLocal1 = t;
            continue;
          }
          var start = l$tailLocal1;
          var remaining$tailLocal1 = t;
          while (true) {
            if (remaining$tailLocal1.b()) {
              var result = start;
              break _return;
            } else {
              var x = remaining$tailLocal1.e();
              if ((!(!(!f(x))))) {
                remaining$tailLocal1 = remaining$tailLocal1.c();
                continue;
              }
              var firstMiss = remaining$tailLocal1;
              var newHead = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(start.e(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
              var toProcess = start.c();
              var currentLast = newHead;
              while ((toProcess !== firstMiss)) {
                var newElem = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(toProcess.e(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
                currentLast.t = newElem;
                currentLast = newElem;
                toProcess = toProcess.c();
              }
              var next = firstMiss.c();
              var nextToCopy = next;
              while ((!next.b())) {
                var head = next.e();
                if ((!(!(!f(head))))) {
                  next = next.c();
                } else {
                  while ((nextToCopy !== next)) {
                    var newElem$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(nextToCopy.e(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
                    currentLast.t = newElem$2;
                    currentLast = newElem$2;
                    nextToCopy = nextToCopy.c();
                  }
                  nextToCopy = next.c();
                  next = next.c();
                }
              }
              if ((!nextToCopy.b())) {
                currentLast.t = nextToCopy;
              }
              var result = newHead;
              break _return;
            }
          }
        }
      }
    }
    var f$1 = ((_$39$2) => _$39$2.E());
    if ((result === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
      var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    } else {
      var x0 = result.e();
      var h$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f$1(x0), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      var t$1 = h$1;
      var rest = result.c();
      while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
        var x0$1 = rest.e();
        var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f$1(x0$1), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
        t$1.t = nx;
        t$1 = nx;
        rest = rest.c();
      }
      var $x_2 = h$1;
    }
    var $x_1 = encoders$lzy5$1.ad($x_2);
  }
  return $x_1;
}
export { $p_Lmealorama_AccountPreferences$__encoders$lzyINIT5$1__sr_LazyRef__sci_List__Lzio_json_ProductMeta__sci_List as $p_Lmealorama_AccountPreferences$__encoders$lzyINIT5$1__sr_LazyRef__sci_List__Lzio_json_ProductMeta__sci_List };
function $p_Lmealorama_AccountPreferences$__encoders$5__sr_LazyRef__sci_List__Lzio_json_ProductMeta__sci_List($thiz, encoders$lzy5$2, fieldLabels$10, meta$30) {
  return (encoders$lzy5$2.G ? encoders$lzy5$2.H : $p_Lmealorama_AccountPreferences$__encoders$lzyINIT5$1__sr_LazyRef__sci_List__Lzio_json_ProductMeta__sci_List($thiz, encoders$lzy5$2, fieldLabels$10, meta$30));
}
export { $p_Lmealorama_AccountPreferences$__encoders$5__sr_LazyRef__sci_List__Lzio_json_ProductMeta__sci_List as $p_Lmealorama_AccountPreferences$__encoders$5__sr_LazyRef__sci_List__Lzio_json_ProductMeta__sci_List };
/** @constructor */
function $c_Lmealorama_AccountPreferences$() {
  this.alz = null;
  this.alA = false;
}
export { $c_Lmealorama_AccountPreferences$ as $c_Lmealorama_AccountPreferences$ };
$p = $c_Lmealorama_AccountPreferences$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_AccountPreferences$;
/** @constructor */
function $h_Lmealorama_AccountPreferences$() {
}
export { $h_Lmealorama_AccountPreferences$ as $h_Lmealorama_AccountPreferences$ };
$h_Lmealorama_AccountPreferences$.prototype = $p;
$p.m = (function() {
  return "AccountPreferences";
});
$p.ts = (function() {
  if ((!this.alA)) {
    var evidence$1$proxy5 = $m_Lmealorama_AccountPreferences$();
    var $x_4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$().ae(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2("scheduledMealPreferences", $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$()), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$()));
    var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var $x_2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
    var $x_1;
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Set$EmptySet$();
    var meta = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lzio_json_ProductMeta($x_4, $x_3, $x_2, $x_1, true, false, false, "mealorama.AccountPreferences");
    var fieldLabels = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon("scheduledMealPreferences", $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
    var construct = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ps$2) => evidence$1$proxy5.aS2(new $j_mealorama$002e$002dAccount$002dPreferences$0024$0024anon$002417.$c_Lmealorama_AccountPreferences$$anon$17(ps$2))));
    var accessors = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((a$2) => a$2.ai)), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
    var this$11 = meta.W;
    _return: {
      var these = this$11;
      while ((!these.b())) {
        if (false) {
          var $x_5 = true;
          break _return;
        }
        these = these.c();
      }
      var $x_5 = false;
    }
    if ($x_5) {
      var noExtra = true;
    } else {
      var noExtra = (!$j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lzio_json_JsonCodecConfiguration$().X.bt);
    }
    var this$18 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedIterableOps__zipWithIndex__O(fieldLabels);
    var f = ((x$1$2) => {
      var label = x$1$2.z();
      var i = (x$1$2.E() | 0);
      var anns = meta.V.ab(label, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())));
      var this$13 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(anns, new $j_mealorama$002e$002dAccount$002dPreferences$0024$0024anon$002418.$c_Lmealorama_AccountPreferences$$anon$18());
      var $x_6 = (this$13.b() ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(label) : this$13.i());
      var this$15 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(anns, new $j_mealorama$002e$002dAccount$002dPreferences$0024$0024anon$002419.$c_Lmealorama_AccountPreferences$$anon$19());
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2($x_6, (this$15.b() ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$() : this$15.i())), i);
    });
    if ((this$18 === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
      var $x_7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    } else {
      var x0$1 = this$18.e();
      var h = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0$1), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      var t = h;
      var rest = this$18.c();
      while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
        var x0$2 = rest.e();
        var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0$2), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
        t.t = nx;
        t = nx;
        rest = rest.c();
      }
      var $x_7 = h;
    }
    var fieldNamesWithAliases = $x_7;
    var numFields = fieldLabels.x();
    if ((numFields === 0)) {
      var decoder = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lzio_json_DeriveHelpers$$anon$8(noExtra, construct);
    } else {
      var $x_10 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lzio_json_DeriveHelpers$();
      var $x_9 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((decoders$lzy5$3) => (() => $p_Lmealorama_AccountPreferences$__decoders$5__sr_LazyRef__ALzio_json_JsonDecoder(this, decoders$lzy5$3)))(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sr_LazyRef()));
      var this$22 = meta.bu;
      var evidence$1__runtimeClass;
      var evidence$1__runtimeClass = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_s_Option.l();
      if ((this$22.O() >= 0)) {
        var length = this$22.O();
        var componentType = evidence$1__runtimeClass;
        var destination = componentType.U.U(length);
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$22, destination, 0, 2147483647);
        var $x_8 = destination;
      } else {
        var capacity = 0;
        var size = 0;
        var jsElems = null;
        var elementClass = evidence$1__runtimeClass;
        capacity = 0;
        size = 0;
        var isCharArrayBuilder = (elementClass === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_C.l());
        jsElems = [];
        var it = this$22.n();
        while (it.l()) {
          var elem = it.k();
          var unboxedElem = (isCharArrayBuilder ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uC(elem) : ((elem === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_scm_ArrayBuilder$().b1(elementClass) : elem));
          jsElems.push(unboxedElem);
        }
        var $x_8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_scm_ArrayBuilder$().b5(((elementClass === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_V.l()) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_jl_Void.l() : (((elementClass === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_sr_Null$.l()) || (elementClass === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_sr_Nothing$.l())) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_O.l() : elementClass)), jsElems);
      }
      var decoder = $x_10.bZ(fieldNamesWithAliases, $x_9, $x_8, noExtra, meta.W, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lzio_json_JsonCodecConfiguration$().X, meta.by, construct);
    }
    var isEmptyProduct = (((fieldLabels.b() || (!meta.bv)) || meta.bw) || meta.bx);
    if (isEmptyProduct) {
      var encoder = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lzio_json_DeriveHelpers$$anon$17();
    } else {
      var encoders$lzy5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sr_LazyRef();
      var f$1 = ((elem$2) => meta.ag.M(elem$2));
      _return$1: {
        var result;
        var l$tailLocal1 = fieldLabels;
        while (true) {
          if (l$tailLocal1.b()) {
            var result = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
            break;
          } else {
            var h$1 = l$tailLocal1.e();
            var t$1 = l$tailLocal1.c();
            if ((!(!f$1(h$1)))) {
              l$tailLocal1 = t$1;
              continue;
            }
            var start = l$tailLocal1;
            var remaining$tailLocal1 = t$1;
            while (true) {
              if (remaining$tailLocal1.b()) {
                var result = start;
                break _return$1;
              } else {
                var x = remaining$tailLocal1.e();
                if ((!(!(!f$1(x))))) {
                  remaining$tailLocal1 = remaining$tailLocal1.c();
                  continue;
                }
                var firstMiss = remaining$tailLocal1;
                var newHead = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(start.e(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
                var toProcess = start.c();
                var currentLast = newHead;
                while ((toProcess !== firstMiss)) {
                  var newElem = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(toProcess.e(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
                  currentLast.t = newElem;
                  currentLast = newElem;
                  toProcess = toProcess.c();
                }
                var next = firstMiss.c();
                var nextToCopy = next;
                while ((!next.b())) {
                  var head = next.e();
                  if ((!(!(!f$1(head))))) {
                    next = next.c();
                  } else {
                    while ((nextToCopy !== next)) {
                      var newElem$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(nextToCopy.e(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
                      currentLast.t = newElem$2;
                      currentLast = newElem$2;
                      nextToCopy = nextToCopy.c();
                    }
                    nextToCopy = next.c();
                    next = next.c();
                  }
                }
                if ((!nextToCopy.b())) {
                  currentLast.t = nextToCopy;
                }
                var result = newHead;
                break _return$1;
              }
            }
          }
        }
      }
      var f$2 = ((label$2) => {
        var anns$1 = meta.V.ab(label$2, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())));
        var this$33 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(anns$1, new $j_mealorama$002e$002dAccount$002dPreferences$0024$0024anon$002420.$c_Lmealorama_AccountPreferences$$anon$20());
        return (this$33.b() ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(label$2) : this$33.i());
      });
      if ((result === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
        var $x_11 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      } else {
        var x0$3 = result.e();
        var h$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f$2(x0$3), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
        var t$2 = h$2;
        var rest$1 = result.c();
        while ((rest$1 !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
          var x0$4 = rest$1.e();
          var nx$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f$2(x0$4), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
          t$2.t = nx$1;
          t$2 = nx$1;
          rest$1 = rest$1.c();
        }
        var $x_11 = h$2;
      }
      var fieldNamesEither = $x_11;
      var encoders = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((encoders$lzy5$3) => (() => $p_Lmealorama_AccountPreferences$__encoders$5__sr_LazyRef__sci_List__Lzio_json_ProductMeta__sci_List(this, encoders$lzy5$3, fieldLabels, meta)))(encoders$lzy5));
      var fieldAnnotations$1 = meta.V;
      var encoder = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lzio_json_DeriveHelpers$$anon$13(accessors, meta.W, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lzio_json_JsonCodecConfiguration$().X, encoders, fieldNamesEither, result, fieldAnnotations$1);
    }
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lzio_json_JsonCodec$();
    this.alz = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lzio_json_JsonCodec(encoder, decoder);
    this.alA = true;
  }
  return this.alz;
});
$p.aS2 = (function(x$0) {
  return new $j_mealorama$002e$002dAccount$002dPreferences.$c_Lmealorama_AccountPreferences(x$0.g(0));
});
var $d_Lmealorama_AccountPreferences$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_AccountPreferences$, "mealorama.AccountPreferences$", ({
  Fg: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_AccountPreferences$ as $d_Lmealorama_AccountPreferences$ };
var $n_Lmealorama_AccountPreferences$;
function $m_Lmealorama_AccountPreferences$() {
  if ((!$n_Lmealorama_AccountPreferences$)) {
    $n_Lmealorama_AccountPreferences$ = new $c_Lmealorama_AccountPreferences$();
  }
  return $n_Lmealorama_AccountPreferences$;
}
export { $m_Lmealorama_AccountPreferences$ as $m_Lmealorama_AccountPreferences$ };
//# sourceMappingURL=mealorama.-Account-Preferences$.js.map
